import { useCallback, useEffect, useRef, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'

export type UseDrawerPortalNode = () => HTMLElement | null

const useDrawerPortalNode: UseDrawerPortalNode = () => {
  const queryClient = useQueryClient()
  const queryCache = queryClient.getQueryCache()

  const unsubscribeFnRef = useRef<() => void>(undefined)

  const [portalNode, setPortalNode] = useState<HTMLElement | null>(
    queryClient.getQueryData<HTMLElement>([
      'drawer-portal-container-node-ref',
    ]) ?? null
  )

  const updateNodeToRender = useCallback(
    (args: any) => {
      if (
        args?.action?.type === 'invalidate' &&
        args.query.queryKey[0] === 'drawer-portal-container-node-ref'
      ) {
        setPortalNode(
          queryClient.getQueryData<HTMLElement>([
            'drawer-portal-container-node-ref',
          ]) ?? null
        )
      }
    },
    [queryClient]
  )

  useEffect(() => {
    setPortalNode(
      queryClient.getQueryData<HTMLElement>([
        'drawer-portal-container-node-ref',
      ]) ?? null
    )

    unsubscribeFnRef.current = queryCache.subscribe(updateNodeToRender)

    return () => {
      if (unsubscribeFnRef.current) {
        unsubscribeFnRef.current()
      }
    }
  }, [queryCache, queryClient, updateNodeToRender])

  return portalNode
}

export default useDrawerPortalNode
